function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isConditionalDef } from '../../../channeldef';
import { getMarkPropOrConfig, signalOrValueRef } from '../../common';
import { wrapCondition } from './conditional';
import * as ref from './valueref';
import { getConditionalValueRefForIncludingInvalidValue } from './invalid';
/**
 * Return encode for non-positional channels with scales. (Text doesn't have scale.)
 */
export function nonPosition(channel, model) {
  var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var markDef = model.markDef,
    encoding = model.encoding,
    config = model.config;
  var vgChannel = opt.vgChannel;
  var defaultRef = opt.defaultRef,
    defaultValue = opt.defaultValue;
  var channelDef = encoding[channel];
  if (defaultRef === undefined) {
    // prettier-ignore
    defaultValue !== null && defaultValue !== void 0 ? defaultValue : defaultValue = getMarkPropOrConfig(channel, markDef, config, {
      vgChannel: vgChannel,
      // If there is no conditonal def, we ignore vgConfig so the output spec is concise.
      // However, if there is a conditional def, we must include vgConfig so the default is respected.
      ignoreVgConfig: !isConditionalDef(channelDef)
    });
    if (defaultValue !== undefined) {
      defaultRef = signalOrValueRef(defaultValue);
    }
  }
  var commonProps = {
    markDef: markDef,
    config: config,
    scaleName: model.scaleName(channel),
    scale: model.getScaleComponent(channel)
  };
  var invalidValueRef = getConditionalValueRefForIncludingInvalidValue(_objectSpread(_objectSpread({}, commonProps), {}, {
    scaleChannel: channel,
    channelDef: channelDef
  }));
  var mainRefFn = function mainRefFn(cDef) {
    return ref.midPoint(_objectSpread(_objectSpread({}, commonProps), {}, {
      channel: channel,
      channelDef: cDef,
      stack: null,
      // No need to provide stack for non-position as it does not affect mid point
      defaultRef: defaultRef
    }));
  };
  return wrapCondition({
    model: model,
    channelDef: channelDef,
    vgChannel: vgChannel !== null && vgChannel !== void 0 ? vgChannel : channel,
    invalidValueRef: invalidValueRef,
    mainRefFn: mainRefFn
  });
}